const route = {
	path: ':subsidiaryId?/accountant',
	name: 'accounting-plans',
	meta: {
		title: 'LISTA PLAN DE CUENTAS',
	},
	component: () => import('@/pages/accounting-plans/page-accounting-plans'),
	props: true,
	children: [
		{
			name: 'activate-accounting-plan',
			path: ':yearAccountantId?/active',
			meta: {
				title: 'Activar Plan de Cuentas',
			},
			component: () => import('@/pages/accounting-plans/page-accounting-plan-active'),
			props: true,
		},
		{
			path: 'new',
			name: 'accounting-new',
			meta: {
				title: 'Nuevo Plan de Cuentas',
			},
			component: () => import('@/pages/accounting-plans/page-accounting-edit'),
			props: true,
		},
		{
			path: ':id/edit',
			name: 'accounting-edit',
			meta: {
				title: 'Editar Plan de Cuentas',
			},
			component: () => import('@/pages/accounting-plans/page-accounting-edit'),
			props: true,
		},
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/accounting-plans.js